"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBytes = void 0;
const utils_1 = require("../utils");
const formatBytes = (bytes, decimals = 2, isSizesShown = true) => {
    if (bytes === 0) {
        return isSizesShown ? '0 Bytes' : '0';
    }
    const multiplier = bytes < 0 ? -1 : 1;
    bytes = multiplier * bytes;
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const sign = multiplier === -1 ? '-' : '';
    const value = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    let result = `${sign}${value}`;
    if (isSizesShown) {
        const size = utils_1.getBytesSize(bytes);
        result += ` ${size}`;
    }
    return result;
};
exports.formatBytes = formatBytes;
//# sourceMappingURL=formatBytes.js.map